import React from "react";
import Styles from "./WorkflowHeader.module.scss";
import Icon from "../../theme/icon/Icon";

export default function WorkflowHeader({ title }: { title?: string }) {
    return (
        <div className={Styles.header}>
            <Icon.Automation background="warning" size="large" variant="warning" isRounded className={Styles.icon} />
            <h5 className={Styles.title}>{title ?? "Automation"}</h5>
        </div>
    );
}

WorkflowHeader.defaultProps = {
    title: undefined,
};
